import { render, staticRenderFns } from "./businessArea.vue?vue&type=template&id=b181102c&scoped=true&"
import script from "./businessArea.vue?vue&type=script&lang=js&"
export * from "./businessArea.vue?vue&type=script&lang=js&"
import style0 from "./businessArea.vue?vue&type=style&index=0&id=b181102c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b181102c",
  null
  
)

export default component.exports